<div gdColumns="repeat(auto-fill, minmax(40%, 1fr))" gdGap="10px">
	<mat-form-field gdColumn="1 / -1">
		<mat-label>Search Nearest Address</mat-label>
		<input
			matInput
			autocomplete="address-search"
			[matAutocomplete]="auto"
			[formControl]="addressSearch"
		/>
		<mat-autocomplete
			#auto="matAutocomplete"
			[displayWith]="displayAddress"
			(optionSelected)="selectLocation($event.option.value)"
		>
			<mat-option
				*ngFor="let address of filteredAddresses$ | async"
				[value]="address"
			>
				<span>{{ address.display_name }}</span>
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>

	<rpshared-map gdColumn="1 / -1" [formControl]="latlng"></rpshared-map>

	<ng-container [formGroup]="form">
		<mat-form-field>
			<input
				type="number"
				matInput
				placeholder="Latitude"
				formControlName="latitude"
			/>
		</mat-form-field>
		<mat-form-field>
			<input
				type="number"
				matInput
				placeholder="Longitude"
				formControlName="longitude"
			/>
		</mat-form-field>
		<mat-form-field gdColumn="1 / -1">
			<input
				matInput
				maxlength="20"
				spellcheck="false"
				autocomplete="off"
				placeholder="Mile Post(s)"
				formControlName="startingMilePost"
			/>
		</mat-form-field>
		<mat-form-field gdColumn="1 / -1">
			<input
				matInput
				autocomplete="distance-from-tracks"
				placeholder="Distance From Tracks"
				formControlName="distanceFromTracks"
			/>
		</mat-form-field>
		<mat-form-field gdColumn="1 / -1">
			<mat-select
				formControlName="subdivision"
				[compareWith]="idComparer"
				placeholder="Subdivision"
			>
				<mat-option>--</mat-option>
				<mat-option
					*ngFor="let subdivision of subdivisions"
					[value]="subdivision"
				>
					{{ displayName(subdivision) }}
				</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field gdColumn="1 / -1">
			<mat-label>Location notes</mat-label>
			<textarea
				matInput
				cdkTextareaAutosize
				formControlName="location"
				#autosize="cdkTextareaAutosize"
				cdkAutosizeMinRows="1"
				cdkAutosizeMaxRows="5"
			>
			</textarea>
		</mat-form-field>
		
		<mat-form-field>
			<input 
				matInput 
				placeholder="City" 
				formControlName="city" />
		</mat-form-field>
		<mat-form-field>
			<input 
				required 
				autocomplete="off"
				matInput 
				placeholder="State" 
				formControlName="state" 
				[matAutocomplete]="state"
				maxlength="2" />
			<mat-autocomplete #state="matAutocomplete">
				<mat-option *ngFor="let state of filteredStates$ | async" [value]="state.code">
					{{ state.name }}
				</mat-option>
			</mat-autocomplete>
			<mat-error *ngIf="form.get('state').hasError('invalidItem')">
				Must be a valid state from the dropdown list.
			</mat-error>
			<mat-error *ngIf="form.get('state').hasError('required')">Required</mat-error>
		</mat-form-field>
	</ng-container>
</div>
